module.exports = __webpack_public_path__ + "static/cover-controlcontainer-e89c60b6244e351d29db0c92f12ba6a3.png";